import * as React from "react"

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 45 45"
    style={{
      enableBackground: "new 0 0 45 45",
    }}
    xmlSpace="preserve"
    {...props}
  >
    <path fill={props.background} d="m43.3 24.3-4.2-11.1c-.1-.3-.4-.5-.7-.5h-9V9.9c0-2.3-1.9-4.2-4.3-4.2H5.9c-2.4 0-4.3 1.9-4.3 4.2v24c0 1.4 1.1 2.5 2.5 2.5h3.3c.6 1.6 2.1 2.8 3.9 2.8s3.4-1.2 3.9-2.8H31c.6 1.6 2.1 2.8 3.9 2.8 1.8 0 3.4-1.2 3.9-2.8h1.9c1.4 0 2.5-1.1 2.5-2.5v-9.4c.2-.1.1-.2.1-.2zM5.9 7.2h19.3c1.5 0 2.8 1.2 2.8 2.7V28H3.1V10c0-1.6 1.3-2.8 2.8-2.8zm5.5 30.4c-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7s2.7 1.2 2.7 2.7c0 1.5-1.2 2.7-2.7 2.7zm23.6 0c-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7 1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7zm6.9-3.7c0 .5-.4 1-1 1h-1.7c0-2.3-1.9-4.2-4.2-4.2-2.3 0-4.2 1.9-4.2 4.2H15.6c0-2.3-1.9-4.2-4.2-4.2s-4.2 1.9-4.2 4.2H4.1c-.5 0-1-.4-1-1v-4.4h25.6c.4 0 .8-.3.8-.8V14.2h8.4l3.9 10.5v9.2z" />
    <path fill={props.background} d="M32.3 16.2c0-.4-.3-.8-.8-.8s-.8.3-.8.8v6.9c0 .4.3.8.8.8h6.9c.4 0 .8-.3.8-.8s-.3-.8-.8-.8h-6.2v-6.1z" />
  </svg>
)

export default SvgComponent
